import type { ResponsiveValues } from '@lemonade-hq/uniclient-theme';
import { MAIN_GRID_COLUMNS } from '../Wizard.css';

export const DEFAULT_COLUMNS = {
  sm: MAIN_GRID_COLUMNS.sm,
  md: MAIN_GRID_COLUMNS.md,
  lg: MAIN_GRID_COLUMNS.lg,
};

export const DEFAULT_COLUMNS_FOR_CONTENT = {
  md: MAIN_GRID_COLUMNS.md,
  lg: 4,
} as const;

export type MdLgColumns = number | { readonly md?: number; readonly lg?: number };

export const getGridColumn = (columns?: MdLgColumns): ResponsiveValues<number> => {
  return {
    sm: DEFAULT_COLUMNS.sm,
    md: Math.min(typeof columns === 'number' ? columns : columns?.md ?? DEFAULT_COLUMNS.md, DEFAULT_COLUMNS.md),
    lg: typeof columns === 'number' ? columns : columns?.lg ?? DEFAULT_COLUMNS.lg,
  };
};
